import { Currency } from '../model/currency.model'

export const USD_CURRENCY = {
  cashSecurityId: 18158,
  id: 1,
  code: 'USD',
  cusip: 'CCYUSD',
}

export const DEFAULT_CURRENCY = USD_CURRENCY

/**
 * Gets the default currency, which is USD.
 */
export function getDefaultCurrency(): Currency {
  return DEFAULT_CURRENCY
}

/**
 * Get currency by code from currency list.
 */
export function getCurrencyFromCurrencyCode(
  currencyCode: string | null | undefined,
  currencyList: Currency[],
): Currency | undefined {
  if (currencyCode == null || currencyCode == undefined) {
    return undefined
  }
  return currencyList.find(currency => currency.code == currencyCode)
}

/**
 * Get currency by cash security id from currency list.
 */
export function getCurrencyFromCashSecurityId(
  securityId: number | null | undefined,
  currencyList: Currency[],
): Currency | undefined {
  if (securityId == null || securityId == undefined) {
    return undefined
  }
  return currencyList.find(currency => currency.cashSecurityId == securityId)
}

/**
 * Get currency by id from currency list.
 */
export function getCurrencyFromId(
  currencyId: number | null | undefined,
  currencyList: Currency[],
): Currency | undefined {
  if (currencyId == null || currencyId == undefined) {
    return undefined
  }
  return currencyList.find(currency => currency.id == currencyId)
}

/**
 * Get currency from cusip
 */
export function getCurrencyFromCusip(
  cusip: string | null | undefined,
  currencyList: Currency[],
): Currency | undefined {
  if (cusip == null || cusip == undefined) {
    return undefined
  }
  return currencyList.find(currency => currency.cusip == cusip)
}
